import { atom, useAtom } from 'jotai';
import type { RewardCenterListRes } from '@/types/api/reward/reward-center-list.d';
import { useCallback } from 'react';
import { getRewardCenterList } from '../services/rewardcenter';

/**
 * 奖励中心计数的原子状态
 */
export const rewardCenterListAtom = atom<RewardCenterListRes>();

/**
 * 使用奖励中心计数管理的 Hook
 * @returns 
 */
export const useRewardCenterManager = () => {
  const [centerData, setCenterData] = useAtom(rewardCenterListAtom);

  /**
   * 通过 API 更新
   */
  const updateCenterList = useCallback(async () => {
    try {
      const response: RewardCenterListRes = await getRewardCenterList();
      setCenterData(response);
      return response;
    } catch (error) {
      console.error('Failed to update reward count:', error);
      throw error;
    }
  }, [setCenterData]);

  return {
    centerData,
    updateCenterList,
  };
};